import { render, staticRenderFns } from "./messageBtn.vue?vue&type=template&id=ed4334b2&scoped=true&"
import script from "./messageBtn.vue?vue&type=script&lang=js&"
export * from "./messageBtn.vue?vue&type=script&lang=js&"
import style0 from "./messageBtn.vue?vue&type=style&index=0&id=ed4334b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4334b2",
  null
  
)

export default component.exports